import { Platform } from "react-native";

// Build-time flags: Expo inlines EXPO_PUBLIC_* values when bundling, so keep
// the direct `process.env.EXPO_PUBLIC_…` references.

// Upload Service v2 (resumable uploads to evt.live, server-side conversion).
// Unset: the native apps use it (the native uploader is in the binary from
// Android 4.3.6 and iOS 4.3.1, so an over-the-air update bundled without the
// variable keeps it on); web keeps the current upload path. "off" keeps the
// current path everywhere, "web" turns v2 on for the web app only, "all" for
// web and the native apps. Anything else is treated as "off".
const rawValue = String(process.env.EXPO_PUBLIC_UPLOAD_V2 || "")
  .trim()
  .toLowerCase();
const rawMode = rawValue || "off";

export const UPLOAD_V2_MODE =
  rawMode === "web" || rawMode === "all" ? rawMode : "off";

export const UPLOAD_V2_API_URL = (
  process.env.EXPO_PUBLIC_UPLOAD_V2_API || "https://evt.live/api/uploads/v2"
).replace(/\/+$/, "");

// Whether this build asks for v2 on a platform. The upload screens also need a
// platform adapter (see isUploadV2Available in useUploadV2.js): a native app
// whose binary lacks the UploadV2 module keeps the current path anyway.
export const isUploadV2Enabled = (os = Platform.OS) =>
  UPLOAD_V2_MODE === "all" ||
  (UPLOAD_V2_MODE === "web" && os === "web") ||
  ((os === "android" || os === "ios") && rawValue === "");
